export class Status {
    id = -1;

    description = '';
}
